function escapeRefinement(value) {
  if (typeof value === 'number' && value < 0) {
    value = String(value).replace(/^-/, '\\-');
  }

  return value;
}

export default escapeRefinement;


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/es/lib/utils/escapeRefinement.js
// module id = null
// module chunks = 